import localesPt from '@/views/Auth/i18n/localePt';

const translations = {
  pt: {
    ...localesPt.pt,
    SEO_TITLE: 'Conecte-se',
    SEO_DESCRIPTION: 'Inicia sesión y aprende nuevas habilidades hoy.',
    FORM_TITLE: 'Aumente seu talento',
    FORM_SUBTITLE: 'Para continuar, defina uma senha para sua conta.',
    INPUT_EMAIL_LABEL: 'E-mail',
    INPUT_EMAIL_HINT: 'Digite seu e-mail',
    INPUT_USERNAME_LABEL: 'Usuário',
    INPUT_USERNAME_HINT: 'Digite seu usuário',
    INPUT_DNI_LABEL: 'DNI',
    INPUT_DNI_HINT: 'Ingresa tu DNI',
    INPUT_PASSWORD_LABEL: 'Senha',
    INPUT_PASSWORD_HINT: 'Digite seu senha',
    FORGOT_PASSWORD: 'Esqueceu sua senha?',
    BUTTON_SUBMIT_LABEL: 'Entrar',
    BUTTON_SUBMIT_EMAIL: 'Confirmar e-mail',
    SOCIAL_LABEL: 'Entrar com:',
    EMAIL_FORM_DESCRIPTION:
      'Atribua um e-mail à sua conta para concluir a configuração',
    CHANGE_PASSWORD_ERROR_MESSAGE:
      'Ocorreu um erro ao alterar a senha. Por favor, tente novamente.',
    LEARNING_SESSION_QUERY_ERROR:
      'Ocorreu um erro ao obter a sessão de aprendizado. Por favor, tente novamente.',
    LEARNING_SESSION_NOT_FOUND:
      'Não foi possível encontrar a sessão de aprendizado. Por favor, contate seu administrador para garantir que sua conta está configurada corretamente.',
    RETRY: 'Tentar novamente',
    RELOAD_PAGE: 'Recarregar página',
    CHANGE_PASSWORD_FORM_TITLE: 'Alterar senha',
    CHANGE_PASSWORD_FORM_DESCRIPTION:
      'Seu administrador solicitou que você atualize sua senha para atender aos requisitos de segurança da organização.',
    CHANGE_PASSWORD_FORM_INPUT_PASSWORD_LABEL: 'Criar senha',
    CHANGE_PASSWORD_FORM_INPUT_PASSWORD_HINT: 'Digite sua senha',
    CHANGE_PASSWORD_FORM_INPUT_CONFIRM_PASSWORD_LABEL: 'Confirmar senha',
    CHANGE_PASSWORD_FORM_INPUT_CONFIRM_PASSWORD_HINT: 'Confirme sua senha',
    CHANGE_PASSWORD_FORM_BUTTON_SUBMIT_LABEL: 'Confirmar senha',
    CHANGE_PASSWORD_FORM_BUTTON_SUBMIT_LABEL_LOADING: 'Mudando senha...',
    PASSWORD_DOES_NOT_MATCH: 'As senhas não coincidem',

    // social auth buttons
    CHANGE_PASSWORD_FORM_REQUIRED: 'Este campo é obrigatório',
    CHANGE_PASSWORD_FORM_MIN_LENGTH:
      'Sua senha deve ter pelo menos 6 caracteres',
    CHANGE_PASSWORD_FORM_MAX_LENGTH:
      'Sua senha não pode ter mais de 50 caracteres',
    CHANGE_PASSWORD_STRENGTH_VERY_WEAK: 'Muito fraca',
    CHANGE_PASSWORD_STRENGTH_WEAK: 'Fraca',
    CHANGE_PASSWORD_STRENGTH_MEDIUM: 'Regular',
    CHANGE_PASSWORD_STRENGTH_STRONG: 'Forte',
    CHANGE_PASSWORD_STRENGTH_REQUIREMENTS_TITLE: 'Requisitos obrigatórios',
    CHANGE_PASSWORD_STRENGTH_REQUIREMENT_TITLE_SINGULAR:
      'Requisito obrigatório',
    CHANGE_PASSWORD_STRENGTH_RETRY: 'Tentar novamente',
    CHANGE_PASSWORD_UNCHANGED_ERROR_TITLE: 'A senha deve ser diferente',
    CHANGE_PASSWORD_UNCHANGED_ERROR_DESCRIPTION:
      'Digite uma nova senha que você não tenha usado anteriormente.',
    BUTTON_LABEL_LOGIN_WITH_GOOGLE_SIGN_IN: 'Entrar com Google',
    BUTTON_LABEL_LOGIN_WITH_MICROSOFT_SIGN_IN: 'Entrar com Microsoft',
    BUTTON_LABEL_LOGIN_WITH_MICROSOFT_SECURE_AUTH: 'Entrar com SecureAuth',
    BUTTON_LABEL_LOGIN_WITH_OPENAGORA: 'Entrar com Openagora',
  },
};

export default translations;
